import { xMedian } from '..';
import { matrixToArray } from './matrixToArray';
/**
 * returns the median of the matrix
 */
export function matrixMedian(matrix) {
    return xMedian(matrixToArray(matrix));
}
//# sourceMappingURL=matrixMedian.js.map